import { isEmpty } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import CardPicker from '../../../../../../packages/kiti/components/form/CardPicker'
import CheckboxInput from '../../../../../../components/form/CheckboxInput'
import ColorPicker from '../../../../../../packages/kiti/components/form/ColorPicker'
import FilterInput from '../../../../../../components/form/FilterInput'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import PlaceFiltersList from '../../../../../places/filters/PlaceFiltersList'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')
  const form = useForm()

  const PRESENTATION_OPTIONS = [
    { id: 'none', name: t('widgets.counterOnly'), icon: 'BsDot' },
    { id: 'bar', name: t('widgets.percentageBar'), icon: 'BsDashSquare' },
    { id: 'circle', name: t('widgets.circularPercentage'), icon: 'BsCircle' }
  ]

  return (
    <>
      <Col width="100%">
        <FormItem label={t('widgets.color')} path={['data', 'color']} Input={ColorPicker} />
      </Col>

      <Col width="100%">
        <FormItem
          label={t('widgets.filters')}
          path={['data', 'filters']}
          Input={FilterInput}
          filtersList={<PlaceFiltersList />}
        />
      </Col>

      <Col width="100%">
        <FormItem label={t('widgets.ignorePeriod')} path={['data', 'ignoreDate']} Input={CheckboxInput} ignoreLabel />
      </Col>

      {!isEmpty(form.data?.filters || []) && (
        <Col width="100%">
          <FormItem
            label={t('widgets.presentation')}
            path={['data', 'presentation']}
            Input={CardPicker}
            options={PRESENTATION_OPTIONS}
            selectOnlyId
          />
        </Col>
      )}
    </>
  )
}

export default EditWidgetForm
